export function resolveServiceRequestUrl({ targetUrl, hostApp, legacyEndpoint, }) {
    if (hostApp !== 'FPG') {
        return legacyEndpoint;
    }
    if (!targetUrl) {
        throw new Error('API_URL is required when hostApp is FPG.');
    }
    let parsedTargetUrl;
    try {
        parsedTargetUrl = new URL(targetUrl);
    }
    catch {
        throw new Error('API_URL must resolve to an absolute http or https URL.');
    }
    if (parsedTargetUrl.protocol !== 'http:' && parsedTargetUrl.protocol !== 'https:') {
        throw new Error('API_URL must resolve to an absolute http or https URL.');
    }
    return `/proxy-api-request?redirect=${encodeURIComponent(targetUrl)}`;
}
